(() => {
  const LOCK_TAGS = new Set(['puratos', 'belcolade']);
  const cache = new Map();
  let running = false;
  let rerun = false;
  let debounceTimer;
  let suppressObserver = false;

  const normalize = value => String(value || '').trim().toLowerCase();

  function isLockedProduct(product) {
    const tags = Array.isArray(product && product.tags) ? product.tags.map(normalize) : [];
    const vendor = normalize(product && product.vendor);
    return tags.some(tag => LOCK_TAGS.has(tag)) ||
      vendor === 'puratos' ||
      vendor === 'belcolade';
  }

  function productHandle(row) {
    const link = row.querySelector('a[href*="/products/"]');
    if (!link) return '';
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (cache.has(handle)) return cache.get(handle);

    const request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3500);
      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          signal: controller.signal
        });
        return response.ok ? await response.json() : null;
      } catch (_) {
        return null;
      } finally {
        clearTimeout(timeout);
      }
    })();

    cache.set(handle, request);
    return request;
  }

  function cartRows() {
    return [...document.querySelectorAll(
      '.cart-item, cart-drawer-item, [data-cart-item]'
    )].filter((row, index, rows) =>
      productHandle(row) && !rows.some((other, otherIndex) =>
        otherIndex < index && other.contains(row)
      )
    );
  }

  function withObserverSuppressed(callback) {
    suppressObserver = true;
    callback();
    setTimeout(() => { suppressObserver = false; }, 0);
  }

  function removeNotices() {
    document.querySelectorAll('.anisana-cart-lock-notice').forEach(node => node.remove());
  }

  function addNotice() {
    removeNotices();
    const cartFooter = document.querySelector('#main-cart-footer');
    const drawerFooter = document.querySelector('cart-drawer .drawer__footer, .drawer__footer');
    if (!cartFooter && !drawerFooter) return;

    const notice = document.createElement('div');
    notice.className = 'anisana-cart-lock-notice';
    notice.innerHTML =
      '<p><strong>Log in om de prijs te zien</strong><br>' +
      'Prijzen van Puratos en Belcolade zijn alleen zichtbaar voor ingelogde klanten.</p>' +
      '<a class="button" href="/account/login">Inloggen</a>';
    if (cartFooter) cartFooter.before(notice);
    else drawerFooter.prepend(notice);
  }

  async function scanCart() {
    if (running) {
      rerun = true;
      return;
    }

    running = true;
    rerun = false;

    try {
      const rows = cartRows();
      rows.forEach(row => row.classList.remove('anisana-cart-item-price-locked'));

      const checks = await Promise.all(rows.map(async row => ({
        row,
        locked: isLockedProduct(await fetchProduct(productHandle(row)))
      })));

      const hasLocked = checks.some(item => item.locked);
      checks.forEach(item =>
        item.row.classList.toggle('anisana-cart-item-price-locked', item.locked)
      );

      withObserverSuppressed(() => {
        if (hasLocked) addNotice();
        else removeNotices();
      });
    } finally {
      running = false;

      if (rerun) {
        rerun = false;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(scanCart, 100);
      }
    }
  }

  function scheduleScan() {
    if (suppressObserver) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(scanCart, 120);
  }

  const observer = new MutationObserver(scheduleScan);

  function start() {
    scanCart();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  ['cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach(eventName =>
    document.addEventListener(eventName, scheduleScan)
  );

  document.addEventListener('click', event => {
    if (event.target.closest(
      'button[name="plus"], button[name="minus"], cart-remove-button, [data-cart-remove]'
    )) scheduleScan();
  });
})();